import { ReactNode, forwardRef, useCallback, useEffect } from 'react'
import { useObjectRef } from 'utils/useObjectRef'
import Styles from './Shimmerer.module.scss'
import cx from 'classnames'

interface Props {
  children?: ReactNode
  variant?: 'primary' | 'secondary'
  overrideChildBackgroundOnHover?: boolean
}

const Shimmerer = forwardRef<HTMLDivElement, Props>((props, fRef) => {
  const ref = useObjectRef<HTMLDivElement>(fRef)
  const { children, variant = 'primary', overrideChildBackgroundOnHover = false } = props

  const mouseMoveEvent = useCallback(
    (e: MouseEvent) => {
      if (!ref.current) return

      const { x, y } = ref.current.getBoundingClientRect()
      ref.current.style.setProperty('--x', (e.clientX - x).toString())
      ref.current.style.setProperty('--y', (e.clientY - y).toString())
    },
    [ref],
  )

  useEffect(() => {
    const refCurrent = ref.current
    if (refCurrent) {
      refCurrent.addEventListener('mousemove', mouseMoveEvent)
    }

    return () => refCurrent?.removeEventListener('mousemove', mouseMoveEvent)
  }, [mouseMoveEvent, ref])

  return (
    <div
      className={cx(Styles.root, Styles[variant], {
        [Styles.overrideChildBackgroundOnHover]: overrideChildBackgroundOnHover,
      })}
      ref={ref}
      aria-label="shimmering-wrapper"
    >
      {children}
    </div>
  )
})

export { Shimmerer }
